import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("blur", this.format)
  }

  disconnect() {
    this.element.removeEventListener("blur", this.format)
  }

  format = () => {
    const value = this.formattedValue
    if (!value) return

    this.element.value = value
    this.dispatch("formatted", { detail: { value } })
  }

  get formattedValue() {
    const value = this.element.value.trim()
    if (!value) return null

    const clock = value.match(/^(\d+):(\d{1,2})$/)
    if (clock) {
      const hours = Number(clock[1])
      const minutes = Number(clock[2])
      if (minutes >= 60) return null

      return this.clockValue(hours, minutes)
    }

    const normalized = value.replace(",", ".")
    if (!/^\d+(?:\.\d*)?$/.test(normalized)) return null

    const decimalHours = Number(normalized)
    if (!Number.isFinite(decimalHours)) return null

    const totalMinutes = Math.round(decimalHours * 60)
    return this.clockValue(Math.floor(totalMinutes / 60), totalMinutes % 60)
  }

  clockValue(hours, minutes) {
    return `${hours}:${minutes.toString().padStart(2, "0")}`
  }
}
